import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	templatesButton: {
		id: 'projects-directory-v3.page-layout.header.open-templates-panel.templates-button',
		defaultMessage: 'Templates',
		description: 'Label of button that opens templates panel in the project list',
	},
});
